import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { exploreMenu } from '../../data/explore-menu';
import { Store } from '@ngxs/store';
import { SetDisplay } from 'src/app/engine/state/engine.actions';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoriesComponent implements OnInit {
  exploreMenu = exploreMenu;

  baseAnatomyCategories = exploreMenu.baseAnatomyCategories;
  categories = exploreMenu.categories;

  constructor(
    private store: Store
  ) { }

  ngOnInit() { }

}
